import { render, staticRenderFns } from "./EditorSidebar.vue?vue&type=template&id=8e027896&scoped=true&"
import script from "./EditorSidebar.vue?vue&type=script&lang=js&"
export * from "./EditorSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EditorSidebar.vue?vue&type=style&index=0&id=8e027896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e027896",
  null
  
)

export default component.exports